/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Deha5 = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M106.657 57.28c-1.322-3.793-4.784-17.976-4.784-17.976S99.234 14.565 90.989 6.979C82.742-.606 66.086.052 66.086.052S51.045-.906 44.811 5.331c-9.491 9.491-17.482 20.778-23.915 50.794-6.431 30.017 1.651 46.343 8.082 54.095 6.432 7.752 20.78 17.482 35.624 16.987 14.843-.493 21.361-2.736 36.776-19.956 13.999-18.127 6.597-46.177 5.279-49.971zM61.88 91.254c-9.791 0-17.729-7.938-17.729-17.729 0-9.795 7.938-17.731 17.729-17.731 9.793 0 17.728 7.936 17.728 17.731-.001 9.791-7.935 17.729-17.728 17.729zm13.1-85.155c22.556-1.263 17.591 19.862 17.591 19.862L74.98 6.099z" />
  </svg>
);
export default extendIcon(Deha5);
